import { Link } from 'react-router-dom'

export function LegalFooter({ compact = false }: { compact?: boolean }) {
  return (
    <footer
      className={compact
        ? 'rounded-[28px] border border-slate-200 bg-white/90 p-4 shadow-sm backdrop-blur'
        : 'rounded-[32px] border border-slate-200 bg-white p-6 shadow-sm md:p-8'}
    >
      <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-emerald-700">
            Legal & trust
          </p>
          <h2 className="mt-2 text-xl font-semibold tracking-tight text-slate-900 md:text-2xl">
            Jasna pravila, manj presenečenj.
          </h2>
          <p className="mt-3 text-sm leading-7 text-slate-600">
            Fukodrom je skupnostna storitev. Tukaj najdeš, kako ravnamo s prijavo, e-pošto,
            analitiko, moderatorskimi posegi in vsebino skupnosti — brez napihnjenih obljub.
          </p>
        </div>

        <div className="grid gap-2 text-sm font-medium text-slate-600 sm:grid-cols-3 md:text-right">
          <Link to="/privacy" className="transition hover:text-slate-900">
            Politika zasebnosti
          </Link>
          <Link to="/terms" className="transition hover:text-slate-900">
            Pogoji uporabe
          </Link>
          <Link to="/acceptable-use" className="transition hover:text-slate-900">
            Sprejemljiva uporaba
          </Link>
        </div>
      </div>

      <div className="mt-5 flex flex-col gap-2 border-t border-slate-200 pt-4 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
        <p>Vprašanja ali GDPR zahteve: privacy@fukodrom.com</p>
        <p>Pred marketinškimi e-sporočili vedno omogočimo odjavo.</p>
      </div>
    </footer>
  )
}
